import { IDropdownMenuLink } from './dropdown_menu';
import { IDropdownMenuData, TDropdownType } from './interfaces';
import { trackDropdownLinkClick } from './tracking';

const LONG_TERM_LINK_TITLE = 'Длительная аренда';
const DAILY_LINK_TITLE = 'Посуточно';
export const DOM_RF_TITLE = 'Аренда квартир от ДОМ.РФ';

const BC_LINK_TITLE = 'Бизнес-центры';
const SC_LINK_TITLE = 'Торговые центры';
const WC_LINK_TITLE = 'Складские комплексы';
const SECONDARY_LINK_TITLE = 'Квартиры';
const JK_FLAT_LINK_TITLE = 'Квартиры в новостройках';
const COTTAGE_LINK_TITLE = 'Дома';
const JKS_LINK_TITLE = 'Жилые комплексы';
const KP_LINK_TITLE = 'Коттеджные поселки';

const getCommercialLinks = (
  data: {
    isBcRegion?: boolean;
    bcUrl?: string;
    isScRegion?: boolean;
    scUrl?: string;
    isWcRegion?: boolean;
    wcUrl?: string;
  }
): IDropdownMenuLink[] => {
  const links: IDropdownMenuLink[] = [];

  if (data.isBcRegion) {
    links.push({
      url: data.bcUrl,
      text: BC_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('BC'),
    });
  }

  if (data.isScRegion) {
    links.push({
      url: data.scUrl,
      text: SC_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('TC'),
    });
  }

  if (data.isWcRegion) {
    links.push({
      url: data.wcUrl,
      text: WC_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('WC'),
    });
  }

  return links;
};

const getRentLinks = (data: IDropdownMenuData): IDropdownMenuLink[] => {
  const links: IDropdownMenuLink[] = [
    {
      url: '/snyat-kvartiru/',
      text: LONG_TERM_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('long_term'),
    }, {
      url: '/posutochno/',
      text: DAILY_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('daily'),
    },
  ];
  if (data.domrfUrl) {
    links.push({
      url: data.domrfUrl,
      text: DOM_RF_TITLE,
      onClick: () => trackDropdownLinkClick('domrf', 'eventSite'),
    });
  }
  return links;
};

const getSaleLinks = (
  data: {
    secondaryUrl?: string;
    jksSaleUrl?: string;
    kpUrl?: string;
  }
): IDropdownMenuLink[] => {
  const links: IDropdownMenuLink[] = [];

  if (data.secondaryUrl) {
    links.push({
      url: data.secondaryUrl,
      text: SECONDARY_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('Flat_old_sale'),
    });
  }

  if (data.jksSaleUrl) {
    links.push({
      url: data.jksSaleUrl,
      text: JK_FLAT_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('JK_sale'),
    });
  }

  if (data.kpUrl) {
    links.push({
      url: data.kpUrl,
      text: COTTAGE_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('KP_sale'),
    });
  }

  return links;
};

const getNewBuildingLinks = (
  data: {
    jksNewobjectsUrl?: string;
    villagesUrl?: string;
  }
): IDropdownMenuLink[] => {
  const links: IDropdownMenuLink[] = [];

  if (data.jksNewobjectsUrl) {
    links.push({
      url: data.jksNewobjectsUrl,
      text: JKS_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('JK_new'),
    });
  }

  if (data.villagesUrl) {
    links.push({
      url: data.villagesUrl,
      text: KP_LINK_TITLE,
      onClick: () => trackDropdownLinkClick('KP_new'),
    });
  }

  return links;
};

export const getLinks = (data: IDropdownMenuData, name: TDropdownType): IDropdownMenuLink[] => {
    switch (name) {
      case 'rent':
        return getRentLinks(data);
      case 'sale':
        return getSaleLinks(data);
      case 'newbuildings':
        return getNewBuildingLinks(data);
      case 'commercial':
        return getCommercialLinks(data);
      default:
        throw new Error('unknown dropdown menu type');
    }
};


// WEBPACK FOOTER //
// ./src/bundles/header/components/dropdown_menu/links.ts